var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"featuredPush"}},[_c('h1',[_vm._v("本地特色推送")])])
}]

export { render, staticRenderFns }